import { render, staticRenderFns } from "./hsbcAssignJudges.vue?vue&type=template&id=4ab8a42c&scoped=true"
import script from "./hsbcAssignJudges.vue?vue&type=script&lang=js"
export * from "./hsbcAssignJudges.vue?vue&type=script&lang=js"
import style0 from "./hsbcAssignJudges.vue?vue&type=style&index=0&id=4ab8a42c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab8a42c",
  null
  
)

export default component.exports